import { NavLink } from "react-router-dom"
export default function Footer(){
    return(
        <>
            <div className="container-fluid p-5 mt-auto shadow-lg">
                <div className="row">
                    <div className="col-md-6 col-lg-3 col-xl-3 col-12 col-sm-6" data-aos="zoom-in" data-aos-anchor-placement="bottom-bottom">
                        <iframe 
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.903378659505!2d77.18048527549752!3d28.542623775714013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1df1d55fb887%3A0xe469935d376ee021!2sDepartment%20of%20Management%20Studies%2C%20Indian%20Institute%20of%20Technology%20Delhi!5e0!3m2!1sen!2sin!4v1785660125111!5m2!1sen!2sin" 
                            className="w-100 rounded shadow-sm" 
                            height="200" 
                            style={{ border: 0 }} 
                            allowFullScreen 
                            loading="lazy" 
                            referrerPolicy="strict-origin-when-cross-origin"
                        ></iframe>
                    </div>
                    <div className="col-md-6 col-lg-5 col-xl-5 col-12 col-sm-6 py-3" data-aos="zoom-in" data-aos-anchor-placement="bottom-bottom">
                        <NavLink to="https://maps.app.goo.gl/dFNK61zM4d1xiL3c9" className="text-decoration-none text-light fs-5">
                            <i className="bi bi-send-fill"> Department of Management Studies, <br/>IIT Delhi, Hauz Khas, New Deli - 110016</i>
                        </NavLink>
                        <br/>
                        <br/>
                        <a href="tel:01126596386" className="text-decoration-none text-light fs-5">
                            <i className="bi bi-telephone-fill me-2"></i>
                            011-2659-6386
                        </a>
                        <br/>
                        <br/>
                        <NavLink to="https://maps.app.goo.gl/dFNK61zM4d1xiL3c9" className="text-decoration-none text-light fs-5">
                            <i className="bi bi-twitter-x pe-5"></i>
                        </NavLink>
                        <NavLink to="https://maps.app.goo.gl/dFNK61zM4d1xiL3c9" className="text-decoration-none text-light fs-5">
                            <i class="bi bi-facebook pe-5"></i>
                        </NavLink>
                        <br/>
                        <br/>
                    </div>
                </div>
            </div>
        </>
    )
}